/**
 * 腾讯地图
 */

import jsonp from '../plugin/jsonp'
import config from '../conf/base.conf'

/**
 * 逆地址解析
 * @param { Object } location
 */
const reverseGeocoder = (lat,lng) => {
  return new Promise((reslove,reject) => {
    if (!lat || !lng) reject('缺少必填参数')
    jsonp(`${config.MAP_BASE_URL}/ws/geocoder/v1/`,{
      key: config.MAP_KEY,
      callbackName: 'QQmap',
      output: 'jsonp',
      location: `${lat},${lng}`
    })
      .then(res => {
        // 处理得到controller需要的数据
        const result = res.result || {}
        const location = result.location || {}
        const addressInfo = result.address_component || { city: '' }
        let city = addressInfo.city
        let province = addressInfo.province
        if (addressInfo.city.indexOf('市') > -1) city = addressInfo.city.replace('市','')
        reslove({
          city,
          ...location,
          province
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}

export default reverseGeocoder
